/**
 * 装配体 Mate 归属工具。
 *
 * 文件职责：
 * 1. 按 SOLIDWORKS 的 lowest common parent 规则解析 Mate 所属装配体；
 * 2. 为序列化、投影和后续多级装配文档拆分提供统一入口；
 * 3. 保持纯函数，不读取运行时对象或 UI 状态。
 */

import type { MateEntityRef } from '../definition';
import { resolveLowestCommonParentAssemblyNodeId } from './AssemblyNodePath';

/**
 * 根据 Mate 参与实体解析所属装配体节点。
 *
 * @param input 解析输入。
 * @returns Mate 所属装配体节点 ID。
 */
export function resolveAssemblyMateOwnerAssemblyNodeId(input: {
  /** 当前 Mate 文档所属装配体 ID。 */
  readonly documentAssemblyId: string;
  /** 参与配合的实体。 */
  readonly entities: readonly MateEntityRef[];
}): string {
  return resolveLowestCommonParentAssemblyNodeId({
    documentAssemblyId: input.documentAssemblyId,
    assemblyNodeIds: input.entities.map((entity) => entity.assemblyNodeId),
  });
}
